import { inject, injectable } from 'inversify';

import { IMonitoringService } from '@desygner/ui-core-monitoring';

import { TYPES } from '../../inversify.types';
import { IUserStoreInjector, IViewerStoreInjector } from '../../store';
import { Status } from '../../store/viewer/viewer.types';

export interface IErrorManager {
  handleUnknownError(error: Error): void;
  handleUnauthorizedError(error: Error): void;
  handleNotFoundError(error: Error): void;
}

@injectable()
export class ErrorManager implements IErrorManager {
  constructor(
    @inject(TYPES.MonitoringService)
    private monitoringService: IMonitoringService,
    @inject(TYPES.Store.Viewer) private viewerStore: IViewerStoreInjector,
    @inject(TYPES.Store.User) private userStore: IUserStoreInjector
  ) {}

  public handleUnknownError(error: Error) {
    const viewerStore = this.viewerStore.getState();

    viewerStore.setStatus(Status.UnknownError);

    console.error('An unknown error occurred:', error);
    this.monitoringService.logException(error as Error);
  }

  public handleUnauthorizedError(error: Error) {
    const viewerStore = this.viewerStore.getState();
    const userStore = this.userStore.getState();

    viewerStore.setStatus(Status.UnauthorizedUser);
    userStore.setIsCredentialValid(false);
    userStore.setIsLoading(false);

    this.monitoringService.logException(error as Error);
  }

  public handleNotFoundError(error: Error) {
    const viewerStore = this.viewerStore.getState();

    viewerStore.setStatus(Status.ProjectNotFound);

    this.monitoringService.logException(error as Error);
  }
}
